/** Подтянуть успешные оплаты ЮKassa, если webhook не дошёл (локальная разработка и т.п.). */
export async function syncPendingPayments(api, schoolId) {
    if (!schoolId) return false;
    const key = `school-payment-sync-${schoolId}`;
    const last = sessionStorage.getItem(key);
    if (last && Date.now() - Number(last) < 60_000) return false;

    const syncRes = await api.post(`/schools/${schoolId}/payments/sync-pending`);
    sessionStorage.setItem(key, String(Date.now()));
    return (syncRes.data?.syncedCount ?? 0) > 0;
}

export async function syncPaymentById(api, schoolId, paymentId) {
    if (!schoolId || !paymentId) return null;
    const res = await api.post(`/schools/${schoolId}/payments/${paymentId}/sync`);
    return res.data;
}
